import http from "../../services/http";

const getConsentimentos = async () => {
  return await http("get", `v1/consentimentos/listar`, []);
};

const addConsentimentos = async (formData) => {
  return await http("post", `v1/consentimentos/alterar`, formData);
};

export { getConsentimentos, addConsentimentos };
